// GENERAL FUNCTIONS



const orderMins = {
  '3_months':189,
  '4_months':129,
  '5_months':129,
  '6_months':129,
  '7_months':129,
  '8_months':129,
  '9_months':129,
  '10_months':129,
  '11_months':129,
  '12_months':99,
  '13_months':99,
  '14_months':99,
  '24_months':99,
}

if(!window.sessionStorage.getItem('termLength')){
  $('#recharge-select').val('12-months').change();
  $('.length-selection').val('12-months').change();
}

setTimeout(()=>{
    // $('.form__zip-fail').hide();
    // $('.form__zip-success').hide();
	$('.zip-bar').removeClass('active');
	$('.zip-wrapper').removeClass('active');
}, 7000);

 
var globalTl = null;

$('.ajax-cart__close-icon').click(()=>{
  $('.theme-ajax-cart').removeClass('is-visible');
  $('.ajax-cart__overlay').removeClass('is-visible');
})

if(window.localStorage.getItem('customer_zip')){
  $('.form__zip-input.js-zip-code').val(window.localStorage.getItem('customer_zip'));
  setTimeout(() => {
    $('.form__zip-input.js-zip-code').trigger("change");
    $('.form__zip-input.js-zip-code').trigger("input");
  }, "1000")
}

const updateCartIcon = (qty)=>{
    // update item count badge
  $('.header-cart__count--badge').text(qty);
  if(qty>0) $('.header-cart__count--badge').css('display','flex');
}

const toggleModal = () => {
  $('.modal-recharge').toggleClass('modal--collapsed');
  $('.modal__inner').toggle('hidden');
}

const showSideCart = () => {
  $('.theme-ajax-cart').addClass('is-visible');
  $('.ajax-cart__overlay').addClass('is-visible');
}

$('.header-cart__icon').click((e)=>{
  e.preventDefault();
  e.stopPropagation();
  showSideCart(e);
});

const showEmptyCart = () => {
  $('.heading-wrapper--cart-page, .cart__empty-cart-message, .cart__heading-container').removeClass('is-hidden');
  $('.cart-drawer.cart__form, .cart-content-wrap, .cart__cost-summary').addClass('is-hidden');
  $('.cart-drawer.cart__form').css('display', 'none');
  $('.ajax-cart__close-icon').css('color', '#000');
}

// get's the most recent term length 
const getTermLength = () => {
  if(globalTl){
    return globalTl;
  }
  else if(sessionStorage.getItem('termLength')){
    return sessionStorage.getItem('termLength');
  }
  else if($('.item__title a').length){
    return $('.item__title a').text().match(/([0-9]*) months/)[0];
  }
  else{
    return '12 months'
  }
  // $('.item__title a').length ? $('.item__title a').text().match(/([0-9]*) months/)[0] : $('#recharge-select').val();
}

const reChargeProps = {"charge_interval_frequency":"1","charge_interval_unit_type":"Months","shipping_interval_frequency":"1","shipping_interval_unit_type":"Months","subscription_id":"204952"}

if($('#recharge-select').length){
  if($('.item__title a').length){
    // add from cart
    $('#recharge-select').val(getTermLength().replace(' ','-'));
  }
  else if(sessionStorage.getItem('termLength')){
    // add from sesion storage
    $('#recharge-select').val(sessionStorage.getItem('termLength').replace(' ','-'))
  }
  if(!sessionStorage.getItem('termLength')){
    toggleModal();
  }
}
let show_zip_bar = false;
if (window.location.pathname==='/collections/living-room-standard' || 
  window.location.pathname==='/collections/living-room-premium' ||
  window.location.pathname==='/collections/bedroom-standard' ||
  window.location.pathname==='/collections/bedroom-premium' ||
  window.location.pathname==='/collections/dining-room-standard' ||
  window.location.pathname==='/collections/dining-room-premium' ||
  window.location.pathname==='/collections/home-office-standard' ||
  window.location.pathname==='/collections/home-office-premium' 
) {
  show_zip_bar = true;
} else {
  if(window.location.pathname!=='/cart' 
    && window.location.pathname!=='/' 
    && !window.location.pathname.includes('/pages') 
    && !window.location.pathname.includes('/blogs')
    && !window.location.pathname.includes('/collections')
  ) {
    show_zip_bar = true;
  }
}

if($('.zip-bar').length && !localStorage.getItem('customer_zip') && window.location.pathname=='/'){
  $('.zip-bar').addClass('active');
  $('.zip-wrapper').addClass('active');
  $('.form__zip-success, .form__zip-fail').css('display', 'none');
}

if($('.modal-recharge .modal__btn').length){
  
  $('.modal-recharge .modal__btn').click(e=>{
    $('#length, .modal__btn').attr('disabled', true);
    $('.term-loading').css('display', 'block');
    e.preventDefault();
    e.stopPropagation();
    const newTL = $('#recharge-select').val().replace('-', ' ');
    globalTl = newTL;
    //console.log('newTL:', newTL);
    // $(`.length-selection option[selected="selected"]`).removeAttr('selected');
    // $(`.length-selection option[value="${newTL}"]`).attr('selected',true);
    $('.length-selection').val(newTL).change();
    sessionStorage.setItem('termLength',newTL);
    if(window.location.pathname.includes('/collections/'))try{updateBundlePrice()}catch(e){console.log('error:', e)}; 
    if($('.collection-item').length) updateCollectionListPrices();
    if($('#template-collection').length) updateCollectionPrices();
    if($('#template-product').length)$('.product_section .price .money').text(`$${(getProduct().price/100).toFixed(2)}`);
    toggleModal();
  })  
}

  // related products atc
$('.related-products .button--add-to-cart, .section-related .button--add-to-cart').click(async function (e){
  e.preventDefault();
  e.stopPropagation();
  
  const termLength = getTermLength().replace('-',' ');
  let variantId = '';
  let relatedProduct = {};
      // console.log(termLength)


  $(e.currentTarget).parent().parent().parent().find('.variant-selection select.variant-selection__variants option').each(function(){
    const thisOption = $(this);
    if(thisOption.text().toLowerCase().match(/[0-9][0-9] months|[0-9] months/)  && thisOption.text().toLowerCase().match(/[0-9][0-9] months|[0-9] months/)[0]===termLength){
      // console.log(thisOption.text().toLowerCase().match(/[0-9][0-9] months|[0-9] months/)[0]);
      relatedProduct = {price: thisOption.data('price'), id:thisOption.val(), sellingPlan:thisOption.data('subscriptionId') }; 
      variantId = thisOption.val()
    }    
  })
   
  // add new variants to cart
  await fetch(`${window.location.origin}/cart/add.js`, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items:
      [{id:relatedProduct.id,selling_plan:relatedProduct.sellingPlan,quantity:1,properties:{...reChargeProps,'number_charges_until_expiration':parseInt(termLength)}}]
    })
  })

  await updateCart();

  $('.theme-ajax-cart').addClass('is-visible');
  $('.ajax-cart__overlay').addClass('is-visible');
  
})

  // update order min html in min cart and cart page
const updateOrderMin = (total) => {
  const termLength = getTermLength().replace(' ', '_');
  const orderMin = orderMins[termLength];


  let appointmentPrice = document.querySelector('div[data-product-id="6928225828958"] .cart__total .money')?.getAttribute('price');
  let walkupPrice = document.querySelector('div[data-product-id="6928227041374"] .cart__total .money')?.getAttribute('price');

  let newTotalPrice = parseFloat(total) - (parseFloat(appointmentPrice) + parseFloat(walkupPrice));
  $('.form__bar span').css('width',(((newTotalPrice)/orderMin) * 100)+ "%");
  
  $('.order-status-bar').css('display', 'block'); 

  if((newTotalPrice)<orderMin){
    // update cart drawer order min
    $('.form__bar span').css('display','block');
    $('.ajax-cart__button').attr('disabled',true);
    $('.cart-drawer .cart-header-inner').addClass('form__head--fail');
    $('.form__minimum-title').text($('.form__minimum-title').data('fail'));
    $('.form__minimum-amount').text(`Add $${ orderMin -(newTotalPrice)} to your order to proceed.`);
    // update cart page order minimum
    if($('.cart-header').length) $('.cart-header').addClass('form__head--fail');
  }
  else{
    // update cart drawer order min
    //$('.form__bar span').css('display','none');
    $('.ajax-cart__button').removeAttr('disabled');
    $('.cart-drawer .cart-header-inner').removeClass('form__head--fail');
    $('.form__minimum-title').text($('.form__minimum-title').data('success'));
    $('.form__minimum-amount').text($('.form__minimum-amount').data('success'));
    // update cart page order minimum
    if($('.cart-header').length) $('.cart-header').removeClass('form__head--fail');
  }
}

  // update cart html in mini cart and cart page
const updateCart = async () => {
  // get fresh cart
  const cart = await fetch('/cart.js').then(d=>d.json());

  // get rid of empty cart html if not empty
  if(cart.item_count>0){
      $('.heading-wrapper--cart-page, .cart__empty-cart-message').addClass('is-hidden');
      $('.cart-drawer.cart__form').css('display', 'block');
      $('.ajax-cart__close-icon').css('color', '#fff');
      $('.cart-drawer.cart__form, .cart-content-wrap, .cart__cost-summary, .cart-drawer').removeClass('is-hidden');
      $('.cart-drawer form').removeClass('visually-hidden');
      $('.cart-drawer.cart__form form').css('height','min-content');
      $('.ajax-cart__close-icon').click(()=>{
        $('.theme-ajax-cart').removeClass('is-visible');
        $('.ajax-cart__overlay').removeClass('is-visible');
    })
  }
  else{
    showEmptyCart();
  }
  // update cart html
  $('.cart__item-list').html('');
  let theNewHtml = ``;
  cart.items.forEach((item,i)=>{
    theNewHtml +=`<div class="prod_${item.handle} cart__card container is-align-center" data-cart-item="${item.id}:a3c4a287c32bfde57be18b564f1fd1be" data-variant-id="${item.id}" data-product-id="${item.product_id}" data-line-item="${i}"> <div class="cart__image ${item.handle}"> <a href="/products/${item.handle}?variant=${item.variant_id}" title="${item.title}" class="cart_page_image">\n<div class="image-element__wrap" style="\n max-height: 150px; max-width: calc(4249 /  3187 * 150px);"> <img alt="${item.title}" class="transition--fade-in lazyautosizes lazyload"  data-src="${item.image}">\n</div>\n<noscript class="noscript"> <img class="" src="${item.image}" alt="${item.title}">\n</noscript></a></div> <div class="cart__info ${item.handle}"> <div class="cart__description"> <div class="cart__text"> <p class="item__title"><a href="/products/${item.handle}?variant=${item.variant_id}">${item.title}</a></p> <p class="item__properties"></p></div> <div class="cart__quantity"> <div class="purchase-details__quantity product-quantity-box" data-line-item-key="1">\n<label class="label is-sr-only" for="quantity">Qty</label>\n<div class="\n    quantity-wrapper\n    field\n    has-addons\n    quantity-style--box\n    is-medium\n  "> <div class="control minus-control"> <span class="\n        quantity-minus\n        quantity-element\n        button\n        is-inverse\n      " data-update-quantity="minus" disabled="">\n<span class="icon " data-icon="minus"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><path d="M94,52H4a2,2,0,0,1,0-4H94a2,2,0,0,1,0,4Z"></path></g></svg>\n</span></span></div> <div class="\n      control\n      quantity-input-control\n      \n        quantity-input-control--fill\n      \n    "> <input class="\n        quantity-input\n        quantity-element\n        input\n      " type="number" min="1" size="2" name="quantity" value="${item.quantity}" data-line-id=""></div> <div class="control plus-control"> <span class="quantity-plus quantity-element button is-inverse" data-update-quantity="plus">\n      \n\n\n  \n\n<span class="icon " data-icon="plus"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><path d="M95,48H52V5a2,2,0,0,0-4,0V48H5a2,2,0,0,0,0,4H48V95a2,2,0,0,0,4,0V52H95a2,2,0,0,0,0-4Z"></path></g></svg>\n\n  \n</span></span></div>\n</div></div> <p class="cart__quantity-warning quantity-warning"></p></div></div> <div class="cart__total"> <p> <span class="money" price="${(item.final_line_price/100)}"> $${(item.final_line_price/100).toFixed(2)}</span><span class="month_text">/mo</span></p></div></div></div>`;
  })
  $('.cart__item-list').html(theNewHtml);
  // appt item setup
  
  $('.appointment-fee .item__title').html('Appointment fee');
  $('.appointment-fee .cart__quantity,.walk-up-fee .cart__quantity').remove()
  $('.appointment-fee .item__properties').html('<span>Zip Code: </span><span class="zip_code_value"></span> <a class="change_zip_code">(change zip code)</a>')
  $('.zip_code_value,.zip_code_value_2').html(window.localStorage.getItem('customer_zip_item'));
  var appt_price = parseFloat($('.appointment-fee .money').attr('price'));
  if (isNaN(appt_price)){
    $('.appt_line_item .ap_price').html('TBD');
  }else{
    $('.appt_line_item .ap_price').html('$' + appt_price);
  }
  // walk-up item setup
  $('.walk-up-fee .item__title').html('Walk-up fee');
  var floor_item = $('.floor_selector').find(':selected').attr('var_id');
  $('.walk-up-fee .item__properties').html('<span class="floor_selected_value"></span> <a class="change_floor">(change floor)</a>')
  var walk_price = parseFloat($('.walk-up-fee .money').attr('price'));
  if (isNaN(walk_price)){
    $('.walkup_line_item .walk_price').html('TBD');
  }
  else{
    $('.walkup_line_item .walk_price').html('$' + walk_price);
  }

  // total fees
  var total_price = appt_price + walk_price;
  if (isNaN(total_price)){
    $('.fee_pricings').html('TBD');
    $('.total_line_item .total_price').html('TBD');
  }
  else{
    $('.fee_pricings').html('$' + total_price + '.00');
    $('.total_line_item .total_price').html('$' + total_price);
  }
  var sub_price = (cart.total_price/100);
  
  var recurring_total = sub_price - total_price;
  if (isNaN(total_price)){
    $('.reecuring_pricings').html('$' + sub_price + '.00/mo'); 
  }
  else{
    $('.reecuring_pricings').html('$' + recurring_total + '.00/mo'); 
  }
  
  // updating walk-up line_item title
  $('.floor_selected_value,.floor_selected_value_2').html(window.localStorage.getItem('customer_floor_item'));
  
  $('.cartd__subtotal-container .money').html(`$${(cart.total_price/100).toFixed(2)}`) 
  resetCartListeners();
  // update item count and make sure no disabled inputs
  $('.cart-count').text(`(${cart.item_count})`)
  $('.cart__quantity .quantity-minus').removeAttr('disabled');

  // update recharge selector if there
  try{
     if($('.length-selection').length) $('#recharge-select').val($('.length-selection').val().replace(' ','-'));
  }
  catch{
    
  }

  // update item count badge
  updateCartIcon(cart.item_count);
  updateOrderMin((cart.total_price/100));
  await checkForDrafts(cart);

  if(window.location.pathname==='/cart') validateCheck();

  try {
    $('.cart__subtotal .money').text(` $${(cart.total_price/100).toFixed(2)}`); 
  } catch(e) {

  }

  $('.term-loading').css('display', 'none');
}

const checkForDrafts = async (cart) => {
  const unavailableItems = [];
  let list = '';

  if (cart?.items?.length) {
    for (const item of cart.items) {
      try {
        const itemStatus = await fetch('/products/' + item.handle + '.js')
          .then(response => response.status);

        if (itemStatus !== 200) {
          list += `<li>${item.title}</li>`;
        }
      } catch(error) {
        console.error(error);
      }
    }

    if (list !== '') {
      if (document.querySelector('#unp_notice')) {
        document.querySelector('#unp_notice').innerHTML = `<p>The following item(s) are out of stock: </p> <ul>${list}</ul><p>Please remove/replace to update your term length</p>`;
        document.querySelector('#unp_notice').classList.add('unp_notice');
      }

      if (document.querySelector('#draft_checkout_notice')) {
        document.querySelector('#draft_checkout_notice').innerHTML = `<p>The following item(s) are out of stock: </p> <ul>${list}</ul><p>Please remove/replace to update your term length</p>`;
        document.querySelector('#draft_checkout_notice').classList.add('unp_notice');
      }
    } else {
      if (document.querySelector('#unp_notice')) {
        document.querySelector('#unp_notice').innerHTML = '';
        document.querySelector('#unp_notice').classList.remove('unp_notice');
      }

      if (document.querySelector('#draft_checkout_notice')) {
        document.querySelector('#draft_checkout_notice').innerHTML = '';
        document.querySelector('#draft_checkout_notice').classList.remove('unp_notice');
      }
    }
  }
}


// SECTION: BUNDLE PAGE LOGIC

const updateBundlePrice = () => {

  const termLength = getTermLength().replace(' ','-');
  const bundleSize = $('#bundle-size').length?$('#bundle-size').val():null;
  const rugSize = $('#rug-size').length?$('#rug-size').val():null;
  var totalPrice = 0;
  console.log('bundleSize:', bundleSize)
  
  $('.bundle-item').each(function (e) {
    const bundleItem = $(this)
    $(this).find(".product__single-variants option").each(function (e){
      const varOption = $(this);

      if(varOption.data('option-1')===(getTermLength().replace(' ','-')) && (bundleSize && varOption.data('option-2')?bundleSize===varOption.data('option-2'):true)){
        var price = varOption.data('price-raw');
        var qty = bundleItem.find('.field.qty').val();
        var total = qty * price;
        totalPrice+=total;
      }
      if(rugSize && (varOption.data('option-1')===(getTermLength().replace(' ','-'))) && (rugSize===varOption.data('option-2'))){
        var price = varOption.data('price-raw');
        var qty = bundleItem.find('.field.qty').val();
        var total = qty * price;
        console.log('price ' + price + '  ' + varOption.data('p'));
        totalPrice+=total;
      }
    })

  });
    
      $('.collection__price').html(Shopify.formatMoney(totalPrice) + Shopify.theme.locale.general.price_suffix);
  
    let pieces = 0;
    $('.collection__products-list .field.qty').each(function(){
      pieces += parseInt(this.value)
    })
  
    $('.collection__qty').text( pieces +' pieces')
    
  }

$('#bundle-size').change(updateBundlePrice);



// adding floor item

$(document).on("click", "#cartClear", async (e) => {
  await fetch(`${window.location.origin}/cart/clear.js`, {method: "POST"});
  if (window.location.pathname === '/cart') {
    window.location.href = '/';
  } else {
    await updateCart();
  }
});

$(document).on("click", ".add_floor_item", function () {
  var vid = $(".floor_item").attr("value");
  var vid2 = $(".floor_item").attr("added_item");
  var avail = $(".floor_item").attr("avail");
  var appointment_price = $(".appointment_item").attr("appointment_price");
  var floor_item = $(".floor_selector").find(":selected").attr("var_title");
  var items = [
    {
      id: vid,
      quantity: 1,
      properties: {
        Floor: floor_item,
      },
    },
  ];
  if (avail === "false") {
    $.ajax({
      async: false,
      type: "POST",
      url: "/cart/add.js",
      data: {
        attributes: {
          'Floor': floor_item,
          'Appointment fee': appointment_price,
        },
        items: items,
      },
      dataType: "json",
      success: function () {
        console.log("Item added to cart");
        $(".floor_item").attr("avail", true);
        $(".floor_item").attr("added_item", vid);
        $(".form__zip-success").hide();
        $(".form__success_fees").show();
        $(".cart-zip-wrapper").addClass("final_fees");
        setTimeout(function () {
          updateCart();
        }, 150);
        localStorage.setItem("customer_floor_item", floor_item);
      },
    });
  } else {
    if (vid === vid2) {
      console.log("Item added already");
      $(".form__zip-success").hide();
      $(".form__success_fees").show();
      $(".cart-zip-wrapper").addClass("final_fees");
    } else {
      $.ajax({
        async: false,
        type: "POST",
        url: "/cart/change.js",
        data: {
          id: vid2,
          quantity: 0,
        },
        dataType: "json",
        success: function () {
          $.ajax({
            async: false,
            type: "POST",
            url: "/cart/add.js",
            data: {
              attributes: {
                'Floor': floor_item,
                'Appointment fee': appointment_price,
              },
              items: items,
            },
            dataType: "json",
            success: function () {
              console.log("Items changed");
              $(".floor_item").attr("avail", true);
              $(".floor_item").attr("added_item", vid);
              $(".form__zip-success").hide();
              $(".form__success_fees").show();
              $(".cart-zip-wrapper").addClass("final_fees");
              setTimeout(function () {
                updateCart();
              }, 150);
              localStorage.setItem("customer_floor_item", floor_item);
            },
          });
        },
      });
    }
  }
});


// appointment fee
function appointment_fee() {
  setTimeout(function () {
    var vid = $(".appointment_item").attr("item_id");
    var vid2 = $(".appointment_item").attr("added_item");
    var avail = $(".appointment_item").attr("avail");
    var appointment_price = $(".appointment_item").attr("appointment_price");
    var appt_code = $(".form__zip-container .form__zip-input.js-zip-code").val();
    var floor_item = $(".floor_selector").find(":selected").attr("var_title");
    var items = [
      {
        id: vid,
        quantity: 1,
        properties: {
          Zipcode: appt_code,
        },
      },
    ];
    
    if (avail === "false") {
      $.ajax({
        async: false,
        type: "POST",
        url: "/cart/add.js",
        data: {
          attributes: {
            'Floor': floor_item,
            'Appointment fee': appointment_price,
          },
          items: items,
        },
        dataType: "json",
        success: function () {
          console.log("Item added to cart");
          $(".appointment_item").attr("avail", true);
          $(".appointment_item").attr("added_item", vid);
          setTimeout(function () {
            updateCart();
          }, 200);
          localStorage.setItem("customer_appointment_item", true);
        },
      });
    } else {
      if (vid === vid2) {
        console.log("Item added already");
        $('.zip_code_value,.zip_code_value_2').html(window.localStorage.getItem('customer_zip_item'));
      } else {
        $.ajax({
          async: false,
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: vid2,
            quantity: 0,
          },
          dataType: "json",
          success: function () {
            $.ajax({
              async: false,
              type: "POST",
              url: "/cart/add.js",
              data: {
                items: items,
              },
              dataType: "json",
              success: function () {
                console.log("Items changed");
                $(".appointment_item").attr("avail", true);
                $(".appointment_item").attr("added_item", vid);
                setTimeout(function () {
                  updateCart();
                }, 200);
                localStorage.setItem("customer_appointment_item", true);
              },
            });
          }
        });
      }
    }
  }, 400);
}


// SECTION: ZIP CODE LOGIC

let zipData = ["07302", "11109", "11120", "11351", "11352", "11371", "11380", "11381", "11386", "11390", "11405", "11424", "11425", "11431", "11437", "11439", "11451", "11499", "11690", "10000", "11202", "11241", "11242", "11243", "11245", "11247", "11251", "11252", "11256", "10311", "10313", "10709", "10707", "10573", "10802", "10543", "10583", "10553", "10551", "11001", "11002", "11003", "07024", "07022", "07657", "07650", "07047", "07093", "07302", "07305", "07304", "07306", "07307", "07094", "07020", "07086", "07030", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11363", "11362", "11563", "11568", "11797", "11791", "11542", "11507", "11530", "11762", "11758", "11804", "11803", "11797", "11793", "11791", "11771", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11797", "11791", "11542", "11507", "11530", "10708", "10801", "10701", "10702", "10704", "10805", "10552", "10550", "10705", "10803", "10804", "10538", "10710", "10703", "10453", "10457", "10036", "10024", "10019", "10018", "10014", "10013", "10004", "10001", "10310", "10305", "10304", "10303", "10302", "10301", "10282", "10280", "10199", "10069", "10983", "10977", "10965", "10964", "10962", "10460", "10458", "10467", "10468", "10451", "10452", "10456", "10454", "10455", "10459", "10474", "10463", "10471", "10466", "10469", "10470", "10475", "10461", "10462", "10464", "10465", "10472", "10473", "11212", "11213", "11216", "11233", "11238", "11209", "11214", "11228", "11204", "11218", "11219", "11230", "11234", "11236", "11239", "11223", "11224", "11229", "11235", "11201", "11205", "11215", "11217", "11231", "11203", "11210", "11225", "11226", "11207", "11208", "11211", "11222", "11220", "11232", "11206", "11221", "11237", "10026", "10027", "10030", "10037", "10039", "10001", "10011", "10018", "10019", "10020", "10036", "10029", "10035", "10010", "10016", "10017", "10022", "10012", "10013", "10014", "10004", "10005", "10006", "10007", "10038", "10280", "10002", "10003", "10009", "10021", "10028", "10044", "10065", "10075", "10128", "10023", "10024", "10025", "10031", "10032", "10033", "10034", "10040", "11361", "11362", "11363", "11364", "11354", "11355", "11356", "11357", "11358", "11359", "11360", "11365", "11366", "11367", "11412", "11423", "11432", "11433", "11434", "11435", "11436", "11101", "11102", "11103", "11104", "11105", "11106", "11374", "11375", "11379", "11385", "11691", "11692", "11693", "11694", "11695", "11697", "11004", "11005", "11411", "11413", "11422", "11426", "11427", "11428", "11429", "11414", "11415", "11416", "11417", "11418", "11419", "11420", "11421", "11368", "11369", "11370", "11372", "11373", "11377", "11378", "10302", "10303", "10310", "10306", "10307", "10308", "10309", "10312", "10301", "10304", "10305", "10314", "11249", "11692", "11691", "11735", "11366", "11365", "11361", "11360", "11359", "11358", "11804", "11803", "11797", "11793", "11791", "11771", "11434", "11433", "11762", "11758", "11432", "11430", "11423", "10036", "10024", "10023", "10019", "10018", "10014", "10004", "10001", "10314", "10309", "10307", "10303", "10069", "10706", "10705", "10701", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11363", "11362", "11797", "11791", "11542", "11507", "11530", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11568", "11797", "11791", "11542", "11507", "11530", "10709", "10707", "10801", "10802", "10803", "10804", "10538", "10543", "10583", "10552", "10553", "10550", "10551", "11001", "11002", "11003", "11004", "11005", "11563", "07203", "11853", "11001", "11002", "11003", "11010", "11020", "11021", "11022", "11023", "11024", "11026", "11027", "11030", "11040", "11042", "11050", "11051", "11052", "11053", "11054", "11055", "11096", "11501", "11507", "11509", "11510", "11514", "11516", "11518", "11520", "11530", "11531", "11542", "11545", "11547", "11549", "11550", "11551", "11552", "11553", "11554", "11555", "15556", "11557", "11558", "11559", "11560", "11561", "11563", "11565", "11566", "15568", "11569", "11570", "11571", "11572", "11575", "11576", "11577", "11579", "11580", "11581", "11582", "11590", "11598", "11599", "11709", "11710", "11714", "11732", "11735", "11737", "11753", "11756", "11758", "11762", "11765", "11771", "11783", "11791", "11793", "11797", "11801", "11802", "11803", "11804", "11815"];
 
let zipValidator = (element) => {
    var $container = $('.form__zip');
    var zipcode = $(element).prev().val();

    if (!isCorrectZip(zipcode) || zipcode == '') {
        console.log('The zip code box has input that is invalid or blank');
        $container.addClass('zip-error');
        $('.cart-section .form__zip-fail').hide();
        $('.cart-section .form__zip-info').show()
        $('.cart-section .form__zip-success').hide();
        $('.cart-section .btn--checkout').addClass('zip-disabled');
        return
    }
    if (isCorrectZip(zipcode) && isAvailableZip(zipcode)) {
        localStorage.setItem('customer_zip_item', zipcode);
        $('.cart-section .form__zip-success').show();
        $('.cart-section .form__zip-container').hide()
        $('.cart-section .form__zip-fail').hide();
        $('.cart-section .form__zip-info').hide();
        $('.cart-section .btn--checkout').removeClass('zip-disabled');
        $container.removeClass('zip-error');
        localStorage.setItem('customer_zip', zipcode);
        appointment_fee()
        var walkup_item = $('.floor_item').attr('avail')
        var appointment_item = $(".appointment_item").attr("avail");
        if (walkup_item === 'true' && appointment_item === 'true'){
          $('.cart-section .form__zip-success').hide();
          $('.cart-section .form__success_fees').show()
          $('.cart-section .cart-zip-wrapper').addClass('final_fees');
        }
        setTimeout(function(){
            $('.cart-section .zip-bar').removeClass('active')
            $('.cart-section .zip-wrapper').removeClass('active')
        }, 7000);
    }
    else {
        $('.cart-section .form__zip-success').hide();
        $('.cart-section .form__zip-fail').show();
        $('.cart-section .form__zip-container').hide()
        $('.cart-section .form__zip-info').hide();
        $('.cart-section .btn--checkout').addClass('zip-disabled');
        $container.addClass('zip-error');
        localStorage.setItem('customer_zip', zipcode);
    }
    $('.js-zip-code').val($(element).prev().val());
  
}


let zipValidator2 = (element) => {
    var $container = $(element).closest('.form__zip'); // the input’s own form container
    var zipcode = $(element).val().trim(); // trim whitespace

    var $success = $container.find('.form__zip-success');
    var $fail = $container.find('.form__zip-fail');
    var $info = $container.find('.form__zip-info');
    var $checkoutBtn = $container.find('.btn--checkout');

    if (!isCorrectZip(zipcode) || zipcode === '') {
        console.log('The zip code box has input that is invalid or blank');
        $container.addClass('zip-error');
        $fail.hide();
        $info.show();
        $success.hide();
        $checkoutBtn.addClass('zip-disabled');
        return;
    }

    if (isCorrectZip(zipcode) && isAvailableZip(zipcode)) {
        $success.show();
        $fail.hide();
        $info.hide();
        $checkoutBtn.removeClass('zip-disabled');
        $container.removeClass('zip-error');
        localStorage.setItem('customer_zip', zipcode);

        setTimeout(function(){
            $container.closest('.zip-bar').removeClass('active');
            $container.closest('.zip-wrapper').removeClass('active');
        }, 7000);
    } else {
        $success.hide();
        $fail.show();
        $info.hide();
        $checkoutBtn.addClass('zip-disabled');
        $container.addClass('zip-error');
        localStorage.setItem('customer_zip', zipcode);
    }

    // update the input value itself
    $(element).val(zipcode);
}


function isCorrectZip(zipcode) {
    let validZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
    return validZip ? true : false;
}
function isAvailableZip(zipcode) {
    return zipData.includes(zipcode);
}

$('.zip-code-trigger').click((e)=>{
	e.preventDefault();   
	$('.zip-bar').toggleClass('active');
	$('.zip-wrapper').toggleClass('active');
})

// add different zip
$(document).on('click','.back_zip_button',function(){
  $('.cart-section .cart_form__zip .form__zip-fail').hide();
  $('.cart-section .cart_form__zip .form__zip-container').show()
})

// zip submission
$('span.zip_submit_button_1').on('click', function(){
  zipValidator(this);
})
$('#header .form__zip-input.js-zip-code').on('input', function(){
  zipValidator2(this);
})
$('#mobile-header .form__zip-input.js-zip-code').on('input', function(){
    zipValidator2(this);
});
$(document).on('click','.change_zip_code,.change_zip_code_2',function(){
  $('.cart-section .cart_form__zip .form__zip-container').show()
  $('.cart-section .cart_form__zip .form__zip-success,.cart-section .cart_form__zip .form__success_fees').hide()
  $('.cart-zip-wrapper').removeClass('final_fees');
})

$(document).on('click','.change_floor',function(){
  $('.cart-section .form__zip-success').show();
  $('.cart-section .form__success_fees,.cart-section .form__zip-container').hide();
  $('.cart-zip-wrapper').removeClass('final_fees');
})
$(document).on('click','.cart__info .change_floor,.cart__info .change_zip_code', function(){
  $('html, body').animate({
    scrollTop: $("#fees").offset().top
  }, 300);
})
setInterval(function(){
  let noFeeData = [ "11101", "11102", "11103", "11104", "11105", "11106", "11109", "11120", "11351", "11352", "11354", "11355", "11356", "11357", "11358", "11359", "11360", "11361", "11362", "11363", "11364", "11365", "11366", "11367", "11368", "11369", "11370", "11371", "11372", "11373", "11374", "11375", "11377", "11378", "11379", "11380", "11381", "11385", "11386", "11390", "11405", "11411", "11412", "11413", "11414", "11415", "11416", "11417", "11418", "11419", "11420", "11421", "11422", "11423", "11424", "11425", "11426", "11427", "11428", "11429", "11430", "11431", "11432", "11433", "11434", "11435", "11436", "11437", "11439", "11451", "11499", "11690", "11691", "11692", "11393", "11694", "11695", "11697", "10034", "10040", "10033", "10032", "10039", "10031", "10030", "10037", "10027", "10035", "10026", "10025", "10029", "10000", "10024", "10023", "10128", "10028", "10021", "10065", "10022", "10017", "10019", "10020", "10036", "10018", "10001", "10011", "10025", "10012", "10013", "10007", "10282", "10280", "10006", "10004", "10005", "10038", "10002", "10009", "10003", "10010", "10016", "10035", "10075", "11201", "11202", "11203", "11204", "11205", "11206", "11207", "11208", "11209", "11210", "11211", "11213", "11214", "11215", "11216", "11217", "11218", "11219", "11220", "11221", "11222", "11223", "11224", "11225", "11226", "11228", "11229", "11230", "11231", "11232", "11233", "11234", "11235", "11236", "11237", "11238", "11239", "11241", "11242", "11243", "11245", "11247", "11249", "11251", "11252", "11256", "10301", "10302", "10303", "10304", "10305", "10306", "10307", "10308", "10310", "10311", "10312", "10313", "10314"];
  let apptFeeData = ["07302", "07024", "07022", "07657", "07650", "07047", "07093", "07305", "07304", "07306", "07307", "10573", "07094", "07020", "07086", "07030", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11568", "11797", "11791", "11542", "11507", "11530", "11762", "11758", "11804", "11803", "11797", "11793", "11791", "11771", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11797", "11791", "11542", "11507", "11530", "10708", "10801", "10701", "10702", "10704", "10805", "10552", "10550", "10705", "10803", "10804", "10538", "10710", "10703", "10453", "10457", "10983", "10977", "10965", "10964", "10962", "10460", "10458", "10467", "10468", "10451", "10452", "10456", "10454", "10455", "10459", "10474", "10463", "10471", "10466", "10469", "10470", "10475", "10461", "10462", "10464", "10465", "10472", "10473", "11803", "11797", "11793", "11791", "11771", "11762", "11758", "10706", "10701", "11577", "11576", "11753", "11743", "11050", "11040", "11030", "11024", "11023", "11020", "11568", "11797", "11791", "11542", "11507", "11530", "10709", "10707", "10801", "10802", "10803", "10804", "10538", "10543", "10583", "10552", "10553", "10550", "10551", "11001", "11002", "11003", "11004", "11005", "11563", "07203", "11853", "11001", "11002", "11003", "11010", "11020", "11021", "11022", "11023", "11024", "11026", "11027", "11030", "11040", "11042", "11050", "11051", "11052", "11053", "11054", "11055", "11096", "11501", "11507", "11509", "11510", "11514", "11516", "11518", "11520", "11530", "11531", "11542", "11545", "11547", "11549", "11550", "11551", "11552", "11553", "11554", "11555", "15556", "11557", "11558", "11559", "11560", "11561", "11563", "11565", "11566", "15568", "11569", "11570", "11571", "11572", "11575", "11576", "11577", "11579", "11580", "11581", "11582", "11590", "11598", "11599", "11709", "11710", "11714", "11732", "11735", "11737", "11753", "11756", "11758", "11762", "11765", "11771", "11783", "11791", "11793", "11797", "11801", "11802", "11803", "11804", "11815"];
  
    let input = $('.js-zip-code').val(); 
    let input2 = $('.js-zip-code').val(); 
    let input3 = $('.js-zip-code').val(); 
    let noZipCode;
    let apptZipCode;
    let dataZipCode;
    if (input){
      noZipCode = noFeeData.some(zip => input.includes(zip));
    }
    if (input2){
      apptZipCode = apptFeeData.some(zip => input2.includes(zip));
    }
    if (input3){
      dataZipCode = zipData.some(zip => input3.includes(zip));
    }
    if (dataZipCode){
      if (noZipCode) {
        $('.appointment_item').attr('item_id','40441715523678');
      } 
      else if (apptZipCode){
        $('.appointment_item').attr('item_id','40468702756958');
      }
      else {
        $('.appointment_item').attr('item_id','40441715523678');
      } 
    }
},1);

// floor selector
$(document).on('change', '.floor_selector', function(){
  validateCheck()
  var floor_value = $(this).val();
  localStorage.setItem('customer_floor', floor_value);
  var floor_item = $(this).find(':selected').attr('var_id');
  $('.floor_item').attr('value',floor_item);
  $('.add_floor_item').removeClass('disabled_btn'); 
  $('.add_floor_item').trigger('click');
});
  $(document).on('keypress','.cart-section .cart-zip-wrapper .form__zip-input',function(e) {
    if(e.which == 13) {
      $(".zip_submit_button_1").trigger("click");
    }
  })
//  $(document).on('keyup','.cart-section .cart-zip-wrapper .form__zip-input', function (e) {
  //  if(e.keyCode === 97) {
    //  $(".zip_submit_button_1").trigger("click");
    //}
  //})
 document.addEventListener("DOMContentLoaded", function () {
  var vl = $("body.cart #cart-count").attr("data");
  if (vl !== "0") {
    $(".zip_submit_button_1").trigger("click");
  }
  if (window.localStorage.getItem("customer_floor")) {
    $(".floor_selector").val(window.localStorage.getItem("customer_floor"));
    var floor_item = $(".floor_selector").find(":selected").attr("var_id");
    $(".floor_item").attr("value", floor_item);
    $(".add_floor_item").removeClass("disabled_btn");
    if (vl !== "0") {
      var walkup_item2 = $(".floor_item").attr("avail");
      var f_v = $(".floor_selector").val();
      if (walkup_item2 === "false") {
        if (f_v !== "Select A Floor") {
          $(".add_floor_item").trigger("click");
        }
      }
    }
  }
});

// SECTION: SHARE CART

jQuery.getScript('https://cdnjs.cloudflare.com/ajax/libs/clipboard.js/2.0.4/clipboard.min.js', function () {
    // var clipboard = new ClipboardJS('.shareInput');
    var clipboard = new ClipboardJS('.shareCartButton.copyBtn', {
        text: function (trigger) {
            let url = 'https://theeverset.com/cart#';
            let res = $.ajax({
                url: '/cart.json',
                dataType: "json",
                success: function (data) {                  
                },
                async: false,
                error: function (err) {
                    console.log(err);
                }
            }).responseText;
            let cart = JSON.parse(res);
            const items = [];
            cart.items.forEach(function (item) {
                items.push({
                    id: item.id,
                    quantity: item.quantity,
                    properties: item.properties
                });
            });
            url += btoa(JSON.stringify(items));
            return url;
        }
    });


    clipboard.on('success', function (e) {
        jQuery('.shareCartButton.copyBtn').addClass('none');
        jQuery('.shareCartButton.copyBtn').removeClass('inline');
        jQuery('.shareCartButton.copied').addClass('inline');
        jQuery('.shareCartButton.copied').removeClass('none');

        setTimeout(function () {
            jQuery('.shareCartButton.copyBtn').addClass('inline');
            jQuery('.shareCartButton.copyBtn').removeClass('none');
            jQuery('.shareCartButton.copied').addClass('none');
            jQuery('.shareCartButton.copied').removeClass('inline');
        }, 10000);
    });
});


// SECTION: CART-DRAWER

// gets all variants of products in cart, so we can find new variant based on term length
const getTermProducts = async () => {
  
  const termProducts = [];

  const cart = await fetch('/cart.js').then(async d=>d.json());

  for(let i=0; i<cart.items.length; i++){
      const item = cart.items[i];
      const masterProduct = {product_id: cart.items[i].product_id,quantity: cart.items[i].quantity, title:cart.items[i].variant_title};
      const fullItemStatus = await fetch(window.Shopify.routes.root + 'products/'+item.handle+'.js').then(async res => {
        if (res.status === 200) {
          const fullItem = await res.json();
          fullItem.variants.forEach(variant=> masterProduct[`${variant.title}`] = variant);

          return termProducts.push(masterProduct);
        }
      });
  }

  return termProducts;
  
}

  // function that updates cart based on new term length
const updateCartTermLength = async (e) => {
  var item_1 = $('.cart-section .cart__form .prod_appointment-fee').clone() 
  var item_2 = $('.cart-section .cart__form .prod_walk-up-fee').clone()

  $('.modal__btn').attr('disabled', true);
  $('.term-loading').css('display', 'block');

  const lengthSelector = $(e.currentTarget);
  
  const newVariants = [];
  
  const termLength = e.currentTarget.value;
  globalTl = termLength;
  sessionStorage.setItem('termLength',termLength);
  // lengthSelector.find('option[selected="selected"]').removeAttr('selected');
  if (termLength === '') {
    lengthSelector.val('12 months');
  }
  lengthSelector.find(`option[value="${termLength}"]`).attr('selected', true);

  const termProducts = await getTermProducts();

  for(let i=0; i<termProducts.length;i++){
    const termProduct = termProducts[i];
    const ogVarTitle = termProduct.title;
    const termVariant = termProduct[ogVarTitle.replace(/([0-9]*) months/,termLength)];
    if(termVariant) newVariants.push(termVariant);
  }

  if (newVariants.length<1) return;

  const cartUpdates = newVariants.map((variant,i)=>({id:variant.id,selling_plan:variant.selling_plan_allocations[0].selling_plan_id,quantity:termProducts[i].quantity,properties:{...reChargeProps,'number_charges_until_expiration':parseInt(termLength)}}))
  console.log(cartUpdates);
  // clear cart
  await fetch(`${window.location.origin}/cart/clear.js`, {method: "POST"});
  $('.appointment_item,.floor_item').attr('avail',false);
  // add new variants to cart
  await fetch(`${window.location.origin}/cart/add.js`, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items:cartUpdates.reverse()})
  })
  
  await updateCart();
  $(".zip_submit_button_1,.add_floor_item").trigger("click");
  
//  $('.cart-section .cart__form .cart__item-list').prepend(item_1);
//  $('.cart-section .cart__form .cart__item-list').prepend(item_2);
      $('#length, .modal__btn').attr('disabled', false)
    $('.term-loading').css('display', 'none');
  if($('.length-selection').length) $('#recharge-select').val(termLength.replace(' ','-'));
}

const updateQuantity = async (e) => {

  e.preventDefault();
  e.stopPropagation();
  
  const element = $(e.currentTarget);
  const curQty = element.hasClass('plus-control') ? parseInt(element.prev().children()[0].value) : parseInt(element.next().children()[0].value)
  const newQty = element.hasClass('plus-control') ? curQty + 1 : curQty - 1;

  let theParent = $(element).parent();

  while(!theParent.attr('data-variant-id')){
      if(theParent.id==="theme-ajax-cart")break;
      theParent = theParent.parent();
  }

  const variantId = theParent.attr('data-variant-id');

  await fetch(window.location.origin+'/cart/change.js',{
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
    'id': variantId,
    'quantity': newQty
    })
  })
  
  updateCart();
}



const resetCartListeners = () => {
    // click listener for qty updates
  $('.cart__quantity .plus-control.control, .cart__quantity .minus-control.control').click((e)=>updateQuantity(e));
  $('.cart__quantity .minus-control.control,  .cart__quantity .plus-control.control').click(()=>setTimeout(updateCart, 100));
}
resetCartListeners();

  // change listener to handle term length change
$('.cart-term-length .length-selection').change((e)=>updateCartTermLength(e));
$('.cart-page-length').change((e)=>updateCartTermLength(e));
  // listener to ATC button to update side cart
 // $('.button--add-to-cart').click((e)=>updateCartTermLength(e))
$('.cart__quantity .quantity-minus').removeAttr('disabled');

$(`.length-selection option[value="${getTermLength()}"]`).attr('selected',true);
$(`.cart-page-length option[value="${getTermLength()}"]`).attr('selected',true);


updateCart();


// SECTION: BUNDLE PAGE  

if($('#template-collection-bundle').length){
    // here set variant and month select to match cart term length
let masterTL = getTermLength();
$('#recharge-select').val(masterTL.replace(' ','-'));
$(`#recharge-select option[selected="selected"]`).removeAttr('selected');
$(`#recharge-select option[value="${masterTL.replace(' ','-')}"]`).attr('selected',true);

$('.bundle-item .qty-minus').click(e=>{
  e.preventDefault();
  e.stopPropagation();
  
  const valueElm = $(e.currentTarget).next();
  const value = parseInt(valueElm.val());

  if(value===0){
    return;
  }
  else if(value === 1){
    $(e.currentTarget).attr("disabled", true);
  }

  valueElm.val(value-1);
  valueElm.attr("value", value-1);

    updateBundlePrice();
})

$('.bundle-item .qty-plus').click(e=>{
  e.preventDefault();
  e.stopPropagation();

  const valueElm = $(e.currentTarget).prev();
  const value = parseInt(valueElm.val());
  
  valueElm.val(value+1);
  valueElm.attr("value", value+1);

  updateBundlePrice();
})

updateBundlePrice();


$('.collection-atc').click(async e=>{
  const items = [];
  const bundleSize = $('#bundle-size').length?$('#bundle-size').val():null;
  const rugSize = $('#rug-size').length?$('#rug-size').val():null;
  $('.bundle-item').each(function (e) {
    const bundleItem = $(this)
    $(this).find(".product__single-variants option").each(function (e){
      const varOption = $(this);
      if(varOption.data('option-1')===(getTermLength().replace(' ','-')) && (bundleSize && varOption.data('option-2') ?bundleSize===varOption.data('option-2'):true)){
        items.push({id:parseInt(varOption.val()),selling_plan:varOption.data('subscriptionId'), quantity:bundleItem.find('.field.qty').val(),properties:{...reChargeProps,number_charges_until_expiration:parseInt(getTermLength())}})
      }
      if(rugSize && (varOption.data('option-1')===(getTermLength().replace(' ','-'))) && (rugSize===varOption.data('option-2'))){
        items.push({id:parseInt(varOption.val()),selling_plan:varOption.data('subscriptionId'), quantity:bundleItem.find('.field.qty').val(),properties:{...reChargeProps,number_charges_until_expiration:parseInt(getTermLength())}})
      }
    })

  })


  await fetch(`${window.location.origin}/cart/add.js`,{
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  })

  await updateCart();

  showSideCart();
})

}


// SECTION: STICK-TERM SELECTOR SPECIFIC
$('.modal.modal-recharge').click(e=>{
  if(e.target===document.querySelector('#recharge-select')) return;
  toggleModal();
})



// SECTION: PRODUCT PAGE
const getProduct = () => {
    const termLength = getTermLength().replace('-',' ');
    const options = [];
    let thisProduct = {};
    const size = $('.product_section #data-variant-option-1').length?$('.product_section #data-variant-option-1').val().toLowerCase():null;

    // find product with matching term length and options
  $('.product_section .variant-selection__variants option').each(function(){
    const thisOption = $(this);
    if(thisOption.text().toLowerCase().match(/[0-9][0-9] months|[0-9] months/)  && thisOption.text().toLowerCase().match(/[0-9][0-9] months|[0-9] months/)[0]===termLength && (size ? thisOption.text().toLowerCase().includes(size):true)){
      thisProduct = {price: thisOption.data('price'), id:thisOption.val(), sellingPlan:thisOption.data('subscriptionId') }; 
    }    
  })
  return thisProduct;
}

  // product page add to cart
$('.product_section .button--add-to-cart[type="submit"]').click(async function(e){
  e.preventDefault();
  e.stopPropagation();

  const termLength = getTermLength().replace('-',' ');
  let variantId = '';

  // // find product with matching term length and options
  // $('.product_section .variant-selection__variants option').each(function(){
  //   console.log($('#data-variant-option-1'))
  //   const size = $('#data-variant-option-1').length && $('.variant-selection__variants').css('display') !== 'none'?$('#data-variant-option-1').val().toLowerCase():null;
  //   const thisOption = $(this);
  //   let price = 0;
  //       console.log(size);
  //       console.log(termLength);
  //       console.log(thisOption.text().toLowerCase());

  //   if(thisOption.text().toLowerCase().includes(termLength) && (size ? thisOption.text().toLowerCase().includes(size):true)){
  //     variantId = thisOption.attr('value');
  //     price = thisOption.attr('value');
  //   }
  // })

  // $('.product_section .variant-selection__variants option').each(function(){
  //   const thisOption = $(this);
  //   if(thisOption.text().includes(termLength)) variantId = thisOption.attr('value');
  // })
  const product = getProduct();
  // add new variants to cart
  await fetch(`${window.location.origin}/cart/add.js`, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items:
      [{id:product.id,selling_plan:product.sellingPlan,quantity:1,properties:{...reChargeProps,'number_charges_until_expiration':parseInt(termLength)}}]
    })
  })

  await updateCart();

  $('.theme-ajax-cart').addClass('is-visible');
  $('.ajax-cart__overlay').addClass('is-visible');

  if(this.classList.contains('add-mattress')){
    $('.add-mattress-modal').addClass('active')
  }else {
    $('.general-product-modal').addClass('active')
  }
  // console.log('btn classList', this.classList)


});

function closeMatModal(e){
  e.preventDefault();

  $('.add-mattress-modal').removeClass('active')
  
}
function closeGenModal(e){
  e.preventDefault();

  $('.general-product-modal').removeClass('active')
  
}
// check correct variant based on selected month
if($('#template-product')){
  $('.product_section #data-variant-option-1').change((e)=>{
    e.preventDefault();
    e.stopPropagation();
    $('.product_section .price .money').text(`$${(getProduct().price/100).toFixed(2)}`);
  })    
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(()=>$('.product_section .price .money').text(`$${(getProduct().price/100).toFixed(2)}`),1000)
  }, false);
}
                                              


// SECTION: CART PAGE

const recordAgreement = async () => {
    const ipRes = await fetch("https://ipgeolocation.abstractapi.com/v1/?api_key=7b61d1236e5c4f5c9f048c716502ecd6").then(d=>d.json());
    var appointment_price = $(".appointment_item").attr("appointment_price");
    var floor_item = $(".floor_selector").find(":selected").attr("var_title");
    // const ipRes = await ipRes.json();

    // records agreement in order notes
    const agreedName = customer ? customer.name : 'null';
    const agreedDate = new Date().toString();
    const agreedIP = ipRes.ip_address;

    jQuery.post(window.Shopify.routes.root + 'cart/update.js', `attributes[agreedName]=${agreedName}&attributes[agreedDate]=${agreedDate}&attributes[agreedIP]=${agreedIP}&attributes[Appointment Fee]=${appointment_price}&attributes[Floor]=${floor_item}`);

    // console.log(agreedName,agreedDate,agreedIP);
}

const validateCheck = () => {
  $('.button.add_to_cart.checkout').addClass('active');    
  const stv = $('.floor_selector').val();

  if(!document.querySelector("#agree").checked || $('.form__zip').hasClass('zip-error') || $('.floor_item').attr('avail') === 'false' || $('.appointment_item').attr('avail') === 'false' || stv !== 'Ground floor' && stv !== 'Floor 2' && stv !== 'Floor 3' && stv !== 'Floor 4' && stv !== 'Floor 5' && stv !== 'I do not live in a walk up' || $('.form__zip-input').val()===''  || $('.cart-header').hasClass('form__head--fail') || $('.unp_notice').length) {
    $('.button.add_to_cart.checkout').removeClass ('active');    
    $('.cart__checkout #checkout').addClass('js-disabled');
    $('.button.add_to_cart.checkout').attr('disabled', true);
    document.querySelector('.cart__checkout a.checkout').style.pointerEvents = 'none';
    console.log('invalid');
  } else {
    recordAgreement();
    $('.button.add_to_cart.checkout').addClass('active');
    $('.cart__checkout #checkout').removeClass('js-disabled');
    $('.button.add_to_cart.checkout').attr('disabled', false);
    document.querySelector('.cart__checkout a.checkout').style.pointerEvents = 'auto';
    console.log('valid');
  }
}


$('.cart__checkout #checkout, .button.add_to_cart.checkout').click(e=>{
  e.preventDefault();
  e.stopPropagation();

  if($('.cart-zip-wrapper .form__zip-input.js-zip-code').val()===''){
    $('.cart-zip-wrapper .form__zip').addClass('zip-error');
    return; 
  }
  
  if(!document.querySelector("#agree").checked) return;
  if($('.form__zip').hasClass('zip-error')|| $('.form__zip-input').val()==='' ||  $('.cart-header').hasClass('form__head--fail')) return window.scroll(0, 0);
  window.location.href=($(e.currentTarget).attr('href')+'?from_cart=true')
})

if(window.location.pathname==='/cart'){
  setTimeout(validateCheck, 500);
  $('.form__zip-input.js-zip-code').change(validateCheck);
}


// const updateTotal = () => {
  
//   let total = 0;
//   const order_min = 89; 
  
//   $('.cart-section .cart__item-list .cart__info').each(function(){
//     const thisItem = $(this);
//     const thisPrice = parseFloat(thisItem.find('.cart__total .money').text().replace('$',''));
//     const thisQty = parseInt(thisItem.find('input.quantity-element.quantity-input').val());
//                 console.log(thisPrice)
//             console.log(thisQty)


//     total += (thisPrice * thisQty);
//             console.log(total)

//   })

//   console.log(total);

//   $('.cart__subtotal .money').text(` $${total} /month`);

//   if(total<order_min){
//     $('.cart-header').addClass('form__head--fail');
//     $('.form__bar span').css('width',((total/order_min) * 100)+ "%");
//     $('.form__minimum-title').text($('.form__minimum-title').data('fail'));
//     $('.form__minimum-amount').text(`Add $${order_min-total} to your order to proceed.`);
//   }
//   else{
//     $('.cart-header').removeClass('form__head--fail');
//     $('.form__bar span').css('width',((total/order_min) * 100)+ "%");
//     $('.form__minimum-title').text($('.form__minimum-title').data('success'));
//     $('.form__minimum-amount').text($('.form__minimum-amount').data('success'));
//   }
// }

// constUpdateCartQty = async (e) => {

//   e.preventDefault();
//   e.stopPropagation();
  
//   const element = $(e.currentTarget);
//   const curQty = element.hasClass('plus-control') ? parseInt(element.prev().children()[0].value) : parseInt(element.next().children()[0].value)
//   const newQty = element.hasClass('plus-control') ? curQty + 1 : curQty - 1;

//   element.hasClass('plus-control') ? $(element.prev().children()[0]).val(newQty) : $(element.next().children()[0]).val(newQty);

//   console.log(element);
//   console.log(newQty)

//   let theParent = $(element).parent();

//   while(!theParent.attr('data-variant-id')){
//       if($(theParent).hasClass('cart__item-list'))break;
//       theParent = theParent.parent();
//   }

//   const variantId = theParent.attr('data-variant-id');

//   await fetch(window.location.origin+'/cart/change.js',{
//     method: "POST",
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({
//     'id': variantId,
//     'quantity': newQty
//     })
//   })

//   if(newQty<1) return theParent.remove();
  
//   updateTotal();
// }

// updateTotal();


// $('.cart-section .cart__quantity .plus-control, .cart-section .cart__quantity .minus-control').click((e)=>constUpdateCartQty(e));

$('.checkout-enable').click(async (e)=>{
  

  var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
  $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'text',
      success: function(data) {
          if (data.indexOf("shipping_interval_frequency") > -1) {
              var paramDomain = 'myshopify_domain=' + window.Shopify.shop;
              try {
                  var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
              } catch (err) {
                  var paramLinker = '';
              }
              var paramCustomer = '';
              window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer;
          } else {
              window.location = '/checkout';
          }
      }
  });
})


// SECTION: DELIVERY-DATE PAGE
$('.section-insurance .recharge-checkout.btn').click(async (e) => {
  e.preventDefault();
  e.stopPropagation();
  const delivery_date = `${document.querySelector('#field-month').value}/${document.querySelector('#field-day').value}/${document.querySelector('#field-year').value}`;
  try {
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) throw new Error(`Failed to fetch cart: ${cartResponse.statusText}`);
    const cart = await cartResponse.json();
    const clearCartResponse = await fetch('/cart/clear.js', { method: 'POST' });
    if (!clearCartResponse.ok) throw new Error(`Failed to clear cart: ${clearCartResponse.statusText}`);
    const newItems = cart.items.map(item => ({
      quantity: item.quantity,
      selling_plan: item.selling_plan_allocation?.selling_plan?.id,
      id: item.variant_id,
      properties: { 
        '_charge_interval_frequency': item.properties.charge_interval_frequency,
        '_charge_interval_unit_type': item.properties.charge_interval_unit_type,
        'number_charges_until_expiration': item.properties.number_charges_until_expiration,
        '_shipping_interval_frequency': item.properties.shipping_interval_frequency,
        '_shipping_interval_unit_type': item.properties.shipping_interval_unit_type,
        '_subscription_id': item.properties.subscription_id,
        delivery_date }
    }));
    console.log('New items to add:', newItems);
    console.log('Adding items to cart');
    const addToCartResponse = await fetch('/cart/add.js', {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: newItems })
    });
    if (!addToCartResponse.ok) {
      const errorText = await addToCartResponse.text();
      throw new Error(`Error adding to cart: ${addToCartResponse.statusText}. Response: ${errorText}`);
    }
    const addToCartResult = await addToCartResponse.json();
    window.location.href = "/checkout";
  } catch (error) {
    console.error('Error in add to cart process:', error);
    alert(`There was an error adding items to your cart: ${error.message}. Please try again or contact support if the problem persists.`);
  }
});



// const setCurrentDate = () => {
//   const newDate = new Date().toLocaleDateString('en-us', {year:"numeric", month:"long", day:"numeric"});
//   $('#field-month').val(newDate.split(' ')[0]);
//   $('#field-day').val(parseInt(newDate.split(' ')[1]));
//   $('#field-year').val(newDate.split(' ')[2]);
// }
// setCurrentDate();

$('.cart__checkout #agree').click(validateCheck);


// SECTION: COLLECTION LIST PAGE
const updateCollectionListPrices = () => {
    //const thisTermLength = $('#recharge-select').val();
    const thisTermLength = getTermLength().replace(' ','-');
  //console.log(thisTermLength)

$('.collection-item').each(function(){
  let totalPrice = 0;
  //find each item and qty and add to price
  $(this).find('.bundle-item').each(function(){
    let qty = parseInt($(this).find('.field.qty').val());
    let foundPrice = false;
    $(this).find('.product__single-variants option').each(function(){
      if($(this).data('option-1')===thisTermLength && !foundPrice){
        totalPrice += (qty * parseFloat($(this).data('price-raw')));
        foundPrice = true;
      }
    })
  })
  // set price in html
  $(this).find('.collection-item__price .money').text(`$${(totalPrice/100).toFixed(2)}/month`)
})
}

if($('.collection-item').length){
  updateCollectionListPrices();
  // $('#recharge-select').change(updateCollectionListPrices)
}


// COLLECTION PAGE
// SECTION: COLLECTION LIST PAGE
const updateCollectionPrices = () => {
  //const thisTermLength = $('#recharge-select').val();
  const thisTermLength = getTermLength().replace(' ','-');
  
  $('.product__grid-item').each(function(){
    let totalPrice = 0;
    //find each item and qty and add to price
      let foundPrice = false;
    $(this).find('.product__single-variants option').each(function(){
      if($(this).data('option-1')===thisTermLength && !foundPrice){
        totalPrice += parseFloat($(this).data('price-raw'));
        foundPrice = true;
      }
    })
    // set price in html
    $(this).find('.product-thumbnail__price .money').text(`$${(totalPrice/100).toFixed(2)}/month`)
  })
}

if($('#template-collection').length){
  updateCollectionPrices();
  // $('#recharge-select').change(updateCollectionPrices)
}

// SECTION: LOGIN PAGE

if(!window.location.search.includes('from_cart=true')){
 $('.cart-redirect').remove();
}

window.addEventListener('load', (event) => {
  document.querySelector("body > div.ajax-cart__overlay").addEventListener('click', (e)=>{
      document.querySelector('.ajax-cart__close-icon').click();
  })})

if(!window.sessionStorage.getItem('termLength')){
  $('#recharge-select').val('12-months').change();
  $('.length-selection').val('12-months').change();
}
